import { createFileRoute } from "@tanstack/react-router";

import LeagueOverview from "@/components/LeagueOverview/LeagueOverview";
import LeagueDetailsForm from "@/components/LeagueProfile/LeagueDetailsForm";
import LeagueProfile from "@/components/LeagueProfile/LeagueProfile";

const Component = () => {
  return (
    <LeagueOverview initialTab="profile">
      <LeagueProfile>
        <LeagueDetailsForm />
      </LeagueProfile>
    </LeagueOverview>
  );
};

export const Route = createFileRoute("/gym/$venueUuid/events/series/create")({
  component: Component,
});
